import { ProductQuoteV3Dimension } from '@orus.eu/dimensions'
import type { QuoteModelInput, RcpaxaQuoteV3 } from '@orus.eu/pricing'

export class RcpaxaQuoteDimension<NAME extends string> extends ProductQuoteV3Dimension<
  NAME,
  1,
  QuoteModelInput,
  RcpaxaQuoteV3
> {}

export const rcpaxaQuoteDimension = new RcpaxaQuoteDimension({
  name: 'rcpaxaQuote',
  displayKeys: { name: 'dimension_name_rcpaxa_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
